import Dashboard from 'layouts/Dashboard/Dashboard.jsx';
import Pages from 'layouts/Pages/Pages.jsx';

var indexRoutes = [
  { path: '/public', name: 'Public', component: Pages },
  { path: '/', name: 'Home', component: Dashboard }
];

export default indexRoutes;
